import React from "react"
import {
    ThemeProvider as StyledComponentsThemeProvider,
    createGlobalStyle,
} from "styled-components"

// ----------------------------------------------------------------------------

const themeBreakpoints = {
    lgUp: "min-width: 1441px",
    mdDown: "max-width: 1440px",
    mdUp: "min-width: 769px",
    smDown: "max-width: 768px",
    smUp: "min-width: 481px",
    xsDown: "max-width: 480px",
}

const themeColors = {
    primary: "#49A5BE",
    primary40: "rgba(73,165,190,0.4)",
    primary20: "rgba(73,165,190,0.2)",
    error: "#FF294F",
    success: "#3DD598",
    pending: "#FFBC42",

    dark: "#000000",
    dark900: "#101010",
    dark700: "#44444F",
    dark650: "#5B5B5B",
    dark600: "#696974",
    dark550: "#6F6F6F",
    dark500: "#717171",
    dark400: "#44444F",
    dark300: "#B5B5BE",
    dark250: "#B0B0B0",
    dark200: "#E2E2EA",
    dark100: "#F3F3F4",
    dark50: "#EEEEEE",

    mainBackground: "#f3f3f4",

    orange: "#EA6C00",
    green: "#4AD7A4",

    grayBorder: "#B0B0B0",
    grayBorderLight: "#E9E9E9",
    grayBorderDisabled: "#CFCFCF",
    tableBorder: "#E3E3E3",

    light: "#FFFFFF",

    menuItemBackground: "rgba(255,255,255,0.34)",
    transparentBg: "rgba(196,196,196,0.6)",
    trasparentBlackBg: "rgba(0,0,0,0.3)",
    trasparentGrayBg: "rgba(0,0,0,0.1)",
    menuMobileBlackBg: "rgba(0,0,0,0.9)",
    arrowBg: "rgba(255,255,255,.7)",

    buttonBackground:
        "linear-gradient(90deg, #FFBC42 -20.07%, #D81159 115.95%)",
}

const themeSpacing = {
    padding: "15px",
    smallPadding: "8px",
    bigPadding: "45px",
    gridPadding: "10px",
    layoutPadding: "76px",

    radius: "10px",

    menuSpacing: "40px",
    menuMarginBottom: "35px",

    searchBoxMenuHeight: "64px",
    searchBoxMenuWidth: "290px",
    searchBoxMenuButton: "50px",

    searchBoxHeight: "100px",
    searchBoxWidth: "925px",
    searchBoxButton: "65px",

    searchSliderHeight: "200px",
    searchSliderPadding: "15px",
    searchSliderMargin: "23px",

    searchFilterMargin: "32px",

    backButtonSize: "40px",
}

const themeFont = {
    logo: {
        size: "34px",
        height: "43px",
    },
    title: {
        size: "48px",
        height: "65px",
    },
    title2: {
        size: "32px",
        height: "44px",
    },
    title3: {
        size: "26px",
        height: "35px",
    },
    text: {
        size: "16px",
        height: "22px",
    },
    small: {
        size: "14px",
        height: "19px",
    },
    medium: {
        size: "18px",
        height: "24px",
    },
    big: {
        size: "20px",
        height: "27px",
    },
    table: {
        head: "11px",
        cell: "14px",
        height: "17px",
    },
    weight: {
        regular: 400,
        medium: 600,
        bold: 700,
    },
}

// ----------------------------------------------------------------------------

export default function ThemeProvider(props) {
    const GloablStyle = createGlobalStyle`
        html, body {
            font-family: "Nunito";
            margin: 0;
        }

        * {
            box-sizing: border-box;
            ::-webkit-scrollbar {
                -webkit-appearance: none;
                width: 7px;
            }

            ::-webkit-scrollbar-thumb {
                border-radius: 4px;

                background-color: rgba(0, 0, 0, 0.4);
                box-shadow: 0 0 1px rgba(255, 255, 255, 0.5);
            }
        }

    `

    const theme = {
        colors: themeColors,
        spacing: themeSpacing,
        font: themeFont,
        breakpoints: themeBreakpoints,
    }

    return (
        <StyledComponentsThemeProvider theme={theme}>
            <GloablStyle />
            {props.children}
        </StyledComponentsThemeProvider>
    )
}
